export default __webpack_public_path__ + "static/media/Headdress of Lunacy.4fd1afda.jpg";